(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kck-mobile-menu"] && !Shopify.designMode) return;
  try {
    /*
    KCKBCK mobile menu: a top-level row with children toggles in place. The click is handled here,
    before the theme's own handler, so the theme does not slide to its second panel.
  */
  window.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const summary = event.target.closest('header-drawer .menu-drawer__menu-container > summary');
      if (!summary) return;

      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;

      event.preventDefault();
      event.stopPropagation();

      const willOpen = !details.open;

      if (willOpen) {
        const list = details.closest('.menu-drawer__menu');
        const others = list ? list.querySelectorAll('.menu-drawer__menu-container[open]') : [];

        for (const other of others) {
          other.removeAttribute('open');
          other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      }

      details.toggleAttribute('open', willOpen);
      summary.setAttribute('aria-expanded', String(willOpen));
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kck-product-buy"] && !Shopify.designMode) return;
  try {
    /*
    KCKBCK product page buy box. Clicks are handled on the window, before the block's own listeners:
    tapping a size selects it, and the button adds the selected size to the cart.
  */
  (() => {
    const LABEL_ADD = 'Añadir al carrito';
    const LABEL_ADDING = 'Añadiendo…';
    const LABEL_ADDED = '¡Añadido!';
    const MESSAGE_PICK = 'Elige una talla.';
    const MESSAGE_ERROR = 'No se ha podido añadir. Inténtalo de nuevo.';

    /** @param {Element} selector */
    const parts = (selector) => {
      const button = selector.querySelector('.kckbck-size-btn');
      const label = selector.querySelector('.kckbck-btn-text');
      let message = selector.querySelector('.kck-buy__message');

      if (!message) {
        message = document.createElement('p');
        message.className = 'kck-buy__message';
        message.setAttribute('role', 'status');
        message.hidden = true;
        selector.append(message);
      }

      return { button, label, message };
    };

    /**
     * @param {Element} selector
     * @param {string} text
     */
    const say = (selector, text) => {
      const { message } = parts(selector);
      message.textContent = text;
      message.hidden = text === '';
    };

    /**
     * @param {Element} selector
     * @param {string} text
     */
    const setLabel = (selector, text) => {
      const { button, label } = parts(selector);
      if (label instanceof HTMLElement) label.dataset.label = text;
      if (button) button.setAttribute('aria-label', text);
    };

    /** @param {Element} selector */
    const prepare = (selector) => {
      if (!(selector instanceof HTMLElement) || selector.dataset.kckBuy === 'ready') return;
      selector.dataset.kckBuy = 'ready';

      const { button } = parts(selector);
      if (button) button.removeAttribute('aria-expanded');
      setLabel(selector, LABEL_ADD);

      const options = selector.querySelectorAll('.kckbck-size-option');
      for (const option of options) option.setAttribute('aria-pressed', 'false');

      // A product with a single size that is in stock has nothing to choose.
      if (options.length === 1 && options[0].getAttribute('data-available') === 'true') {
        options[0].setAttribute('aria-pressed', 'true');
      }
    };

    const prepareAll = () => {
      for (const selector of document.querySelectorAll('.kckbck-size-selector')) prepare(selector);
    };

    /**
     * @param {Element} selector
     * @param {Element} option
     */
    const add = (selector, option) => {
      const { button } = parts(selector);
      const id = Number(option.getAttribute('data-variant-id'));
      const root = /** @type {any} */ (window).Shopify?.routes?.root || '/';

      if (!id || !(button instanceof HTMLButtonElement)) return;

      button.disabled = true;
      say(selector, '');
      setLabel(selector, LABEL_ADDING);

      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity: 1 }),
      })
        .then((response) =>
          response.json().then((data) => {
            if (!response.ok) throw new Error(data?.description || MESSAGE_ERROR);
          })
        )
        .then(() => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }))
        .then((response) => response.json())
        .then((cart) => {
          for (const icon of document.querySelectorAll('cart-icon')) {
            const bubble = /** @type {any} */ (icon);
            if (typeof bubble.renderCartBubble === 'function') bubble.renderCartBubble(cart.item_count);
          }

          // Same event the block used to send: the cart panel listens for it and opens.
          document.dispatchEvent(
            new CustomEvent('kckbck:cart-update', {
              bubbles: true,
              detail: { cart, addedVariantId: String(id) },
            })
          );

          setLabel(selector, LABEL_ADDED);
          setTimeout(() => {
            setLabel(selector, LABEL_ADD);
            button.disabled = false;
          }, 1500);
        })
        .catch((error) => {
          say(selector, error instanceof Error && error.message ? error.message : MESSAGE_ERROR);
          setLabel(selector, LABEL_ADD);
          button.disabled = false;
        });
    };

    window.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const selector = event.target.closest('.kckbck-size-selector');
        if (!selector) return;

        const option = event.target.closest('.kckbck-size-option');
        const button = event.target.closest('.kckbck-size-btn');
        if (!option && !button) return;

        // The block's own listeners (open the dropdown, add on tap) must not run.
        event.preventDefault();
        event.stopPropagation();
        prepare(selector);

        if (option) {
          if (option.getAttribute('data-available') !== 'true') return;

          for (const other of selector.querySelectorAll('.kckbck-size-option')) {
            other.setAttribute('aria-pressed', String(other === option));
          }
          say(selector, '');
          return;
        }

        const selected = selector.querySelector('.kckbck-size-option[aria-pressed="true"]');
        if (!selected) {
          say(selector, MESSAGE_PICK);
          return;
        }

        add(selector, selected);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepareAll, { once: true });
    } else {
      prepareAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
